export const strings = {
    prefixAgo: null,
    prefixFromNow: null,
    suffixAgo: '',
    suffixFromNow: '',
    seconds: '1sn',
    minute: '1d',
    minutes: '%dd',
    hour: '1s',
    hours: '%ds',
    day: '1g',
    days: '%dg',
    month: '1ay',
    months: '%day',
    year: '1y',
    years: '%dy',
    wordSeparator: ' ',
};
